module.exports = "images/doc-program-print-1.534842bda71e59c2d91eff1e4e26acfe.png";